import {Controller} from "@hotwired/stimulus"
import Swiper from "swiper"
import { Navigation, Keyboard } from 'swiper/modules';

export default class extends Controller {
  static targets = [  "carousel" ]
  static values = {
    initialSlideIndex: Number,
    keyboardNavigation: { default: false, type: Boolean },
  }

  connect() {
    this.initCarousel()
  }

  initCarousel() {
    this.swiper = new Swiper(this.carouselTarget, {
      modules: [Navigation, Keyboard],
      initialSlide: this.initialSlideIndexValue,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        addIcons: false
      },
      watchSlidesProgress: true,
      slidesPerView: 1,
      speed: 1,
      loop: true,
      lazyPreloadPrevNext: true,
      simulateTouch: false,
      keyboard: {
        enabled: this.keyboardNavigationValue,
        onlyInViewport: true,
      }
    })
  }

  goToSlide(slideNumber) {
    this.swiper.slideTo(slideNumber, 0)
  }
}
